module.exports = __webpack_public_path__ + "img/c5201704-5.91a6d1a9.jpg";